import React, { useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import { Button, Dropdown, Modal } from '../';
import { FileTypes } from '../../services/scraper';
import { useModal } from '../../hooks';

type DownloadButtonWithSelectionProps = {
  onDownload: (fileType: FileTypes) => void;
  downloading?: boolean;
};

const fileTypeOptions = [
  { value: FileTypes.JSON, label: 'JSON' },
  { value: FileTypes.ZIP, label: 'ZIP' },
];

export const DownloadButtonWithSelection: React.FC<
  DownloadButtonWithSelectionProps
> = ({ onDownload, downloading = false }) => {
  const [selectedFileType, setSelectedFileType] = useState<string>(
    FileTypes.JSON
  );
  const { isOpened, onOpen, onClose } = useModal();

  const handleConfirmDownload = () => {
    onDownload(selectedFileType as FileTypes);
    onClose();
  };

  return (
    <>
      <Button
        label="Download"
        onClick={onOpen}
        type="contrast"
        size="small"
        className="px-4"
        icon={<DownloadIcon className="h-4 w-4" />}
        disabled={downloading}
      />

      <Modal
        open={isOpened}
        onClose={onClose}
        size="small"
        title="Select File Type"
        contentClassName="p-6"
      >
        <div className="flex flex-col gap-6">
          <div>
            <label className="block mb-2 text-sm font-medium text-mainText">
              Choose download format:
            </label>
            <Dropdown
              options={fileTypeOptions}
              value={selectedFileType}
              onChange={value => setSelectedFileType(value as FileTypes)}
              placeholder="Select format"
            />
          </div>

          <div className="flex justify-end gap-3">
            <Button
              label="Cancel"
              onClick={onClose}
              type="contrast"
              size="small"
              className="px-6"
            />
            <Button
              label="Download"
              onClick={handleConfirmDownload}
              size="small"
              className="px-6"
              icon={<DownloadIcon className="h-4 w-4" />}
              disabled={downloading}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
